/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@mui/material";
import { useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { Vocabulary } from "../../Utils/Vocabulary";
import { UrlEnum } from "../../Utils/Utils";
import classes from "./Login.module.scss";
import { postData } from "../../Services/postData";
import theme from "../../Theme/Theme";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  /**
   *
   * @param event
   */
  function onChangeTextField(event: any) {
    setEmail(event.target.value);
  }

  /**
   *
   */
  async function handleSubmit() {
    try {
      if (!email) {
        alert(Vocabulary.emailRequired);
        return;
      }
      const response = await postData(UrlEnum.resetPassword,{email:email});
      if (response.data) {
        setEmailSent(true);
      }
    } catch (err: any) {
      //
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.image}>
        <img src={"/yzzy-logo.png"} alt="Yzzy" width="100%" />
      </div>
      {emailSent ? (
        <div className={classes.emailSent}>
          <p>{Vocabulary.resetEmailSent}</p>
        </div>
      ) : (
        <ValidatorForm className={classes.form} onSubmit={handleSubmit}>
          <TextValidator
            variant="filled"
            required={true}
            id="email"
            name="email"
            label={Vocabulary.email}
            validators={["required"]}
            value={email}
            onChange={(e) => onChangeTextField(e)}
            className={classes.textField}
            inputProps={{
              style: {
                color: theme.palette.whiteColor?.main,
              },
            }}
            InputLabelProps={{
              style: {
                color: theme.palette.whiteColor?.main,
              },
            }}
          />

          <Button variant="contained" type="submit" className={classes.button}>
            {Vocabulary.resetPassword}
          </Button>
        </ValidatorForm>
      )}


    </div>
  );
}
